module.exports = __webpack_public_path__ + "img/rawcs.0747a4d.png";